


















import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { ReferralNode } from '@/api/model/referral-node'
import { Question } from '@/views/Form/Conversation.vue'
import Conversation from '@/views/Form/Conversation.vue'
import axios from 'axios'
import moment from 'moment'
import { ReferralType } from '@/api/types'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL
const basePathPdf = process.env.VUE_APP_KEYVUE_PDF_API_BASEPATH || ''
const baseUrlPdf = process.env.VUE_APP_KEYVUE_PDF_API_BASEURL

@Component({
    components: {
        Conversation,
    },
})
export default class Checklist extends Mixins(VhFixMixin) {
    company: Company = null
    companyLoading: boolean = true
    companyError: boolean = false
    submitted: boolean = null

    async mounted() {
        await this.loadCompany()
    }

    async loadCompany(): Promise<void> {
        this.companyLoading = true

        try {
            const response = await axios.get(`${baseUrl}${basePath}/companies/` + this.$route.query.company)
            this.company = Company.fromData(response.data)
            if ('companyName' in this.$route.query && this.$route.query.companyName.length) {
                this.company.branding.displayName = this.$route.query.companyName as string
            }
            this.$root.$currentCompany = this.company
        } catch (err) {
            this.companyError = true
        } finally {
            this.companyLoading = false
        }
    }

    get questions(): Question[] {
        const questions: Question[] = [{
            question: `Een checklist om een woning te bezichtigen? Dat regel ik gratis voor jou en volledig op maat in minder dan een minuut. Zullen we beginnen?`,
            model: 'wants_checklist',
            choices: {
                true: 'Ja',
                false: 'Nee',
            },
        }]

        if (this.answers.wants_checklist === 'false') {
            questions.push({
                question: `Oké 😊. Mocht je van mening veranderen, dan kun je op de knop hieronder klikken. 👇`,
                input: 'button',
                inputAttrs: {
                    title: 'Toch aanvragen',
                },
                inputListeners: {
                    click: () => {
                        window.location.reload(true)
                    },
                },
            })
            return questions
        }

        questions.push({
            question: `Wat is de postcode van de woning die je van plan bent te gaan bezichtigen?`,
            model: 'zipcode',
            inputAttrs: {
                name: 'Postcode',
                rules: 'required|zipcode',
            },
        })

        questions.push({
            question: `En wat is het huisnummer inclusief eventuele toevoeging?`,
            model: 'number',
            inputAttrs: {
                name: 'Huisnummer',
                rules: 'required',
                inputmode: 'decimal',
            },
        })

        questions.push({
            question: `Leuk, dan ga ik dat direct voor je in orde maken! Wat is jouw voornaam?`,
            model: 'firstname',
            inputAttrs: {
                name: 'Voornaam',
                rules: 'required',
            },
        })

        questions.push({
            question: `Oké ${this.answers.firstname}, ik heb nog een paar vragen om de checklist meteen te kunnen versturen. Wat is jouw achternaam?`,
            model: 'lastname',
            inputAttrs: {
                name: 'Achternaam',
                rules: 'required',
            },
        })

        questions.push({
            question: `Weet je toevallig ook de vraagprijs van de woning?`,
            model: 'knows_askingprice',
            choices: {
                true: 'Ja',
                false: 'Nee',
            },
        })

        if (this.answers.knows_askingprice === 'true') {
            questions.push({
                question: `Wat is de vraagprijs?`,
                model: 'price',
                input: 'money',
                inputAttrs: {
                    name: 'Vraagprijs',
                    rules: 'required|numeric',
                    inputmode: 'decimal',
                },
            })
            questions.push({
                question: `En is dit kosten koper, of vrij op naam?`,
                model: 'priceType',
                choices: {
                    kk: 'Kosten koper',
                    von: 'Vrij op naam',
                },
            })
        }

        questions.push({
            question: `We zijn er bijna, weet je ook de datum van de bezichtiging?`,
            model: 'knows_date',
            choices: {
                true: 'Ja',
                false: 'Nee',
            },
        })

        if (this.answers.knows_date === 'true') {
            questions.push({
                question: `Wat is de datum van bezichtiging?`,
                model: 'date',
                inputAttrs: {
                    type: 'date',
                    name: 'Bezichtigingsdatum',
                    rules: 'required',
                    placeholder: 'dd-mm-yyyy',
                },
                formatAnswer: (value: string): string => moment(value).format('LL'),
                defaultAnswer: moment().format('YYYY-MM-DD'),
            })
        }

        questions.push({
            question: `De laatste vraag ${this.answers.firstname}, naar welk e-mailadres mag de checklist gestuurd worden?`,
            model: 'email',
            inputAttrs: {
                name: 'E-mailadres',
                type: 'email',
                rules: 'required|email',
                inputmode: 'email',
            },
        })

        questions.push({
            question: `We hebben alles om jou binnen vijf minuten een checklist te sturen. Alleen hebben wij nog conform de AVG jouw toestemming nodig om je gegevens op te mogen slaan conform de privacy voorwaarden van ${this.company.branding.displayName}. We gebruiken de gegevens alleen om te voldoen aan jouw verzoek en de opvolging daarvan.`,
            model: 'avg',
            choices: {
                true: 'Ik ga akkoord',
                false: 'Ik ga niet akkoord',
            },
            onValidate: (answer): true|string => {
                if (answer === 'false') {
                    return 'We hebben jouw toestemming nodig om je een checklist te sturen.'
                }

                return true
            },
            afterLeave: async (): Promise<void>  => {
                await this.submit()
            },
        })

        if (this.submitted === true) {
            questions.push({
                question: `Super, bedankt voor je checklist aanvraag. 👍 Ik heb alle gegevens ontvangen en zal de checklist spoedig opstellen en e-mailen. ✉ Nog een hele fijne dag vandaag ${this.answers.firstname}! 👋`,
            })
        }

        if (this.submitted === false) {
            questions.push({
                question: `Sorry, er is iets misgegaan. Probeer het later opnieuw.`,
            })
        }

        return questions
    }

    answers = {
        wants_checklist: null,
        zipcode: null,
        number: null,
        firstname: null,
        lastname: null,
        knows_askingprice: null,
        price: null,
        priceType: null,
        knows_date: null,
        date: null,
        email: null,
    }

    async submit(): Promise<void> {
        this.submitted = null

        try {
            const data = {
                zipcode: this.answers.zipcode,
                number: ((this.answers.number as string).match(/\d+/g) ?? []).join(),
                suffix: ((this.answers.number as string).match(/[a-zA-Z]+/g) ?? []).join(),
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                price: this.answers.price,
                priceType: this.answers.priceType,
                date: new Date(this.answers.date),
                email: this.answers.email,
            }

            const hash = (await axios.post(`${baseUrlPdf}${basePathPdf}/checklist`, {
                ...data,
                company: this.company.id,
            })).data.hash

            const checklistUrl = `${baseUrlPdf}${basePathPdf}/checklist/${hash}`
            const comment = this.answers.date
                ? `Er is een checklist aangevraagd voor postcode ${this.answers.zipcode} en huisnummer ${this.answers.number}. U kunt deze <a target="_blank" href="${checklistUrl}">hier</a> vinden. De woning wordt bezichtigd op: ${moment(this.answers.date).format('LL')}`
                : `Er is een checklist aangevraagd voor postcode ${this.answers.zipcode} en huisnummer ${this.answers.number}. U kunt deze <a target="_blank" href="${checklistUrl}">hier</a> vinden.`

            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                email: this.answers.email,
                type: ReferralType.PURCHASE,
                data: {
                    ...data,

                    checklist_url: checklistUrl,
                    checklist_datum_bezichtiging: this.answers.date ? moment(this.answers.date).format('DD-MM-YYYY') : null,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: 'checklist_purchase',
                },
                comment,
            })

            this.submitted = true
        } catch (error) {
            this.submitted = false
        }
    }

    get canRequestChecklist(): boolean {
        if (!this.company) {
            return false
        }

        this.company.ensureIncomingReferralsAreLoaded().then()

        return this.company.incomingReferrals.some((node: ReferralNode) => node.type as unknown as ReferralType === ReferralType.PURCHASE)
    }
}
